import { Component } from '@angular/core';
import {
  NavController,
  ToastController,
  ModalController,
  LoadingController,
  NavParams,
  IonicPage,
  Events
} from 'ionic-angular';

import { PodcastService } from '../../providers/podcast-service';
import { SubscriptionService } from '../../providers/subscription-service';
import { AudioService } from '../../providers/audio-service';

import { EpisodeListPage } from '../episode-list/episode-list';
import { ExplorePage } from '../explore/explore';

import { API_TIMEOUT } from '../../providers/config';

@IonicPage()
@Component({
  selector: 'page-podcast-list',
  templateUrl: 'podcast-list.html'
})

export class PodcastListPage {
  podcasts: any[];

  constructor(
    public navCtrl: NavController, public loadingCtrl: LoadingController,
    public toastCtrl: ToastController, public modalCtrl: ModalController,
    public navParams: NavParams, public events: Events,
    public subscriptionService: SubscriptionService,
    public podcastService: PodcastService,
    public audioService: AudioService
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PodcastListPage');
  }

  ionViewWillEnter() {
    this.reloadData().then((podcasts: any[]) => {
      this.podcasts = podcasts;
    });
  }

  // for pull-to-refresh
  doRefresh($event) {
    this.reloadData().then((podcasts: any[]) => {
      this.podcasts = podcasts;
      $event.complete();
    });
  }

  // reload list data
  reloadData() {
    return new Promise(resolve => {
      // fetching subscriptions
      this.subscriptionService.podcasts().subscribe((podcasts: any[]) => {
        resolve(podcasts);
      });
    });
  }

  loadEpisodeList(event, podcast) {
    this.navCtrl.push(EpisodeListPage, { podcast });
    event.stopPropagation();
  }

  unsubscribe(event, podcast) {
    if (confirm(`Unsubscribing from "${podcast.title}"?`)) {
      this.subscriptionService.unsubscribe(podcast._id).subscribe((success: Boolean) => {
        if (success) {
          let loader = this.loadingCtrl.create({
            content: 'Refreshing your subscriptions...',
            duration: API_TIMEOUT
          });
          loader.present();
          // load initial data
          this.reloadData().then((podcasts: any[]) => {
            this.podcasts = podcasts;
            loader.dismiss();
          });
        } else {
          alert('oops'); // TODO: handle this
        }
      });
    }
    event.stopPropagation();
  }

  explore() {
    this.navCtrl.push(ExplorePage);
  }

  playLastEpisode(event, podcast) {
    let loader = this.loadingCtrl.create({
      content: 'Fetching latest episode...',
      duration: API_TIMEOUT
    });
    loader.present();
    // fetching latest episode
    this.podcastService.lastEpisode(podcast._id).subscribe((episode) => {
      // starting playback
      this.audioService.playTrack(episode);
      loader.dismiss();
    });
    event.stopPropagation();
  }

  logout() {
    this.events.publish('user:logout');
  }

}



// WEBPACK FOOTER //
// ./src/pages/podcast-list/podcast-list.ts